import { blobticService } from '../../Commun/services/blobticService';

export interface Document {
    id: number;
    uid?: string;
    vehIdf?: number;
    drvIdf?: number;
    type?: string;
    title?: string;
    expiryDate?: Date;
    lastUpdate?: Date;
    userId?: number;
    // Joined info
    vehRegistration?: string;
    drvLicenseNumber?: string;
}

interface DocumentDto {
    DOC_IDF: number;
    DOC_UIDF?: string;
    VEH_IDF?: number;
    DRV_IDF?: number;
    DOC_TYPE?: string;
    DOC_TITLE?: string;
    DOC_EXPIRY_DATE?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
    // Joined info
    VEH_REGISTRATION?: string;
    DRV_LICENSE_NUMBER?: string;
}

const mapDtoToModel = (dto: DocumentDto): Document => ({
    id: dto.DOC_IDF,
    uid: dto.DOC_UIDF,
    vehIdf: dto.VEH_IDF,
    drvIdf: dto.DRV_IDF,
    type: dto.DOC_TYPE,
    title: dto.DOC_TITLE,
    expiryDate: dto.DOC_EXPIRY_DATE ? new Date(dto.DOC_EXPIRY_DATE) : undefined,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF,
    vehRegistration: dto.VEH_REGISTRATION,
    drvLicenseNumber: dto.DRV_LICENSE_NUMBER
});

export const documentsApi = {
    getDocuments: async (params?: any) => {
        let actionParams: any = { OKey: 'Blobtic_Parc,parc_document,select' };

        if (params) {
            const { searchParams, ...restParams } = params;
            if (searchParams) {
                actionParams = { ...actionParams, ...searchParams };
            }
            actionParams = { ...actionParams, ...restParams };
        }

        actionParams.joins = '[{"Table":"TABP_PARC_VEHICLE","Alias":"V","On":"TABP_PARC_DOCUMENT.VEH_IDF = V.VEH_IDF","Type":"LEFT"},{"Table":"TABP_PARC_DRIVER","Alias":"D","On":"TABP_PARC_DOCUMENT.DRV_IDF = D.DRV_IDF","Type":"LEFT"}]';
        actionParams.fields = 'TABP_PARC_DOCUMENT.*, V.VEH_REGISTRATION as veh_registration, D.DRV_LICENSE_NUMBER as drv_license_number';

        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: actionParams
        });

        if (response.success && Array.isArray(response.data)) {
            return response.data.map((item: any) => mapDtoToModel(item));
        }
        throw new Error(response.message || 'Failed to fetch documents');
    },

    createDocument: async (data: Partial<Document>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_document,insert',
            VEH_IDF: data.vehIdf,
            DRV_IDF: data.drvIdf,
            DOC_TYPE: data.type,
            DOC_TITLE: data.title,
            DOC_EXPIRY_DATE: data.expiryDate?.toISOString()
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });

        if (response.success && response.data && (response.data as any[]).length > 0) {
            return mapDtoToModel((response.data as any[])[0]);
        }
        throw new Error(response.message || 'Failed to create document');
    },

    updateDocument: async (id: number, data: Partial<Document>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_document,update',
            DOC_IDF: id,
            VEH_IDF: data.vehIdf,
            DRV_IDF: data.drvIdf,
            DOC_TYPE: data.type,
            DOC_TITLE: data.title,
            DOC_EXPIRY_DATE: data.expiryDate?.toISOString()
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });

        if (response.success && response.data && (response.data as any[]).length > 0) {
            return mapDtoToModel((response.data as any[])[0]);
        }
        throw new Error(response.message || 'Failed to update document');
    },

    deleteDocument: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_document,delete', DOC_IDF: id }
        });

        if (!response.success) {
            throw new Error(response.message || 'Failed to delete document');
        }
        return response;
    }
};
